import { RuleBuilderField } from '../../create-report/rule-builder';

export const checkIfHasEditingRuleBuilderField = (
  fields: RuleBuilderField[],
): boolean =>
  fields.some((field) => field.rules.some((rule) => rule.isEditing));
